<template>
  <div class="help-details-obscurator fade-obscurator" v-show="show">
    <div class="help-details-sidebar slide-left">
      <b-row class="text-start">
        <b-col class=" pt-3" style="display:flex; padding-left: 30px;">
          <i class="no no-lg no-c-question-3 text-blue align-self-center pb-1 pr-3"></i>
          <h4 style="font-size: 1.3em; color: #12576e;">Painel de ajuda</h4>
        </b-col>

        <b-col cols="2" class=" ml-auto align-self-center"
          ><div @click="handleCloseSideBar" class="mb-0">
            <i title="Fechar" class="no no-e-remove text-blue sidenav-toggler"></i>
            </div
        ></b-col>
      </b-row>
      <div class="mt-3 ml-4 mb-3" style="font-size: 16px;">Entre em contato com o suporte Janoo:</div>
      <a href="https://wa.me/5577988351872" class="mt-3 ml-4 text-gray" >・WhatsApp: 75 9875-6701</a> </br>
      <a href="mailto:suporte@janoo.com.br" class="mt-1 ml-4 text-gray" >・E-mail: suporte@janoo.com.br</a>
       <!-- <div class="help-detail-dado pt-3 pl-3">
          <div v-if="loadingInfos">
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton animation="wave" width="85%"></b-skeleton>
            <b-skeleton-img no-aspect height="200px"></b-skeleton-img>
          </div>
          <div v-else>
            <h5>Título Teste</h5>
            <div>Descrição Teste</div>
            <img src="./../../assets/img/place_holder_image.png" />-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MoneyFormat from "../../providers/MoneyFormat";
var $ = require("jquery");
export default {
  name: "zendesk-helper",
  props: ["info", "map", "showHelpSideBar", "loadingInfos"],
  data() {
    return {
      show: false,
      data: []
    };
  },
  methods: {
    showDetails() {
      $(document).ready(() => {
        $("body").css("overflow-y", "hidden");
        this.show = true;
        this.createData();
        console.log("SHOWWW");
      });
    },
    handleCloseSideBar() {
      this.show = false;
      this.$emit("help-info-dismiss");
    },

    createData() {
      const arr = [
        { title: "#", data: "Title 1" },
        { title: "Imagem", data: null },
        { title: "Nome", data: "help name" },
        { title: "Preço", data: "Price help 1" }
      ];
      this.data = arr;
    }
  },
  mounted() {
     $(".help-details-obscurator").click(() => {
       $(document).ready(() => {
         $("body").css("overflow-y", "auto");
         this.show = false;
         this.$emit("help-info-dismiss");
       });
     });
  },
  watch: {
    showHelpSideBar(val) {
      if (val) {
        this.showDetails();
      }
    }
  }
};
</script>

<style>
.help-details-obscurator {
  position: fixed;
  left: 0;
  top: 50px;
  width: 100%;
  height: 100vh;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
}

.help-details-sidebar {
  width: 400px;
  height: 100%;
  background: #fff;
  padding: 1em;
  overflow-y: auto;
  right: -100px;
  position: absolute;
}

.help-detail-dado {
  margin-bottom: 8px;
}

.help-detail-dado h5 {
  margin: 0;
  font-size: 1em;
}
.help-detail-dado div {
  font-size: 0.95em;
  color: #888;
}
.help-detail-dado img {
  width: 100%;
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden;
}

/** ANIMATION */
.slide-left {
  -webkit-animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.fade-obscurator {
  -webkit-animation: fade-obscurator 0.5s;
  animation: fade-obscurator 0.5s;
}
@-webkit-keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-100px);
    transform: translateX(-100px);
  }
}
@keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-100px);
    transform: translateX(-100px);
  }
}

@keyframes fade-obscurator {
  0% {
    background: rgba(0, 0, 0, 0);
  }
  100% {
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
